module.exports = __webpack_public_path__ + "img/part-one-thumb.fa38713.jpg";